<template>
  <!-- data.nameShow || (data.type === 'mutual' || data.type === 'swiper') ? {height:0} : '', -->
  <div :class="classNameShow()" :style="[
      getTitle(),
      titleBgfillSet(data)
    ]">
    <div
      :class="['title', data.nameShow ? '' : 'title-cc']"
      v-if="
        (data.type === 'detailed' && drawer === false) ||
        (data.type === 'summary' && drawer === false)
      "
      :style="[
        data.type === 'detailed' && data.showWay === 4 ? {paddingLeft: '10px'} : '', 
        data.summaryTitleConfig, 
        { alignItems: 'center', justifyContent: (data.summaryTitleConfig && data.summaryTitleConfig.textAlign || 'left') } 
      ]"
    >
      <template v-if="!data.nameShow">
        <template v-if="data.img">
          <img v-if="typeof data.img === 'string'"
              :src="'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + data.img"
              style="width: 16px;height:16px;" />
          <icon-module
            v-else
            style="width: 24px;height:24px;"
            :config="data.img">
          </icon-module>
        </template>
        {{ data.reName || "未命名" }}
      </template>
      <slot></slot>
    </div>
    <div class="title" v-else-if="data.type === 'Sizer'">
      <!--<i class="iconfont icon-shaixuan2" />-->{{ data.datasName || "筛选组件" }}
    </div>
    <div class="title" v-else-if="data.type === 'indicatorsBread'" :style="[
      {color: theme && theme.titleColor ? theme.titleColor : ''},
      !isMobile ? data.summaryTitleConfig : {},
      {justifyContent: (data.summaryTitleConfig && data.summaryTitleConfig.textAlign || 'left')}
    ]">
      <template v-if="!data.nameShow">
        <template v-if="data.img">
          <img v-if="typeof data.img === 'string'"
              :src="'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + data.img"
              style="width: 16px;height:16px;" />
          <icon-module
            v-else
            style="width: 24px;height:24px;"
            :config="data.img">
          </icon-module>
        </template>
        <div style="display:flex;align-items:center;">{{ data.isRowVirtual == false && drawer === false ? data.reName : "" }}</div>
      </template>
      <slot></slot>
      <div v-if="data.chartTypeMom" class="chartList">
        <div :class="['chart-l', ll === data.chartType ? 'chart-active' : '']" v-for="ll in data.chartList" :key="ll.chartType || ll" @click="upChart(ll)">
          <i v-if="(ll.chartType || ll) === 'indicators'" class="iconfont iconColor1 iconStyle1 icon-zhibiaotu2x-02"></i>
          <img v-else :src="iconUrl + '/checked/' + (ll.chartType || ll) + '.svg'" />
        </div>
      </div>
    </div>
    <div class="selectBox" :class="isFrontEnd && data.type !== 'text' ? 'admin-selectBox' : ''">
      <!-- 明细表，汇总表 -->
      <template
        v-if="
          data.type === 'detailed' ||
          data.type === 'summary' ||
          data.type === 'indicatorsBread' ||
          data.type === 'mutual' || 
					data.type === 'swiper'
        "
      >
        <!-- 客户端显示 -->

        <template v-if="isFrontEnd == false && data.type !== 'mutual' && data.type !== 'swiper' && (data.titleMom || !data.titleMom && data.titleMom !== false)">
          <div class="select-box-right">
            <a
              v-if="drawer == false"
              class="icon-click-style"
              @click="enlarge(data, index)"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="放大"
                placement="top"
              >
                <i class="iconfont icon-fangda1"></i>
              </el-tooltip>
            </a>
            <a
              :class="
              btnLimitStatus ? 'icon-click-style disabled' : 'icon-click-style'
            "
              @click="update(data, index)"
            >
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                btnLimitStatus ? '您的刷新频率过高，请稍后再试' : '刷新'
              "
                placement="top"
              >
                <i class="iconfont icon-shuaxin"></i>
              </el-tooltip>
            </a>

            <el-tooltip
                class="item"
                effect="light"
                content="下载"
                placement="top"
                v-if="panduanCanUpload() && data.type === 'summary'"
              >
                <template #content>
                  <div>
                    <div class="down-b" @click="uploadPDF(data, index)">PDF 下载</div>
                    <div class="down-b" @click="upload(data, index)">EXCEL 下载</div>
                  </div>
                </template>
                <i class="iconfont icon-xiazai" style="margin-right: 11px;"></i>
            </el-tooltip>

            <a
              class="icon-click-style"
              v-if="panduanCanUpload() && data.type !== 'summary'"
              @click="upload(data, index)"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="下载"
                placement="top"
              >
                <i class="iconfont icon-xiazai"></i>
              </el-tooltip>
            </a>
            <a
              class="icon-click-style"
              v-if="panduanCanUpload() && data.isSource && data.isSource === 2"
              @click="synchronous(data, index)"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="手动数据同步"
                placement="top"
              >
                <i class="WSiconfont WSicon-tongbu"></i>
              </el-tooltip>
            </a>

            <a
              class="icon-click-style"
              v-if="data.relevance && data.relevance.length > 0 && !isRelevancy"
              @click="empty(index)"
            >
              <el-tooltip
                class="item"
                effect="dark"
                content="清空关联"
                placement="top"
              >
                <i class="iconfont icon-qingkongshaixuan"></i>
              </el-tooltip>
            </a>
          </div>
          <i class="iconfont icon-gengduo2 icon-unfold" />
        </template>
      </template>
    </div>
    <multilevelTables ref="multilevelTable"
                      :titleConfig="data.titleConfig"
                      :tableData="fromdatas"
                      :merge="data.merge"
                      :column="data.column" :watermark="data.watermark" :pdfPrint="data.pdfPrint" :title="data.reName" />
    <!-- 背景填充设置 -->
    <!-- <bgfill 
    v-if="bgfillView" 
    :bgfillView="bgfillView"
    :fillStyle="data.bgfllStyle"
    @close="closeFill" @bgSubmit="bgfillSet" /> -->
  </div>
</template>
<script>
import { apiUpateview } from '@/port/admins/instrument'//- 表格数据请求接口
import { serverPageSummary, filterStr, toolbarSearch } from '@/api/instrumentControl';//- 封装方法请求
import { refreshapprovalreport } from '@/port/admins/report'
import { setCustomData } from '@/util/customData.js'
import { defineAsyncComponent } from 'vue';

export default {
  name: 'selectBoxItem',
  props: {
    //- 当前组件数据
    data: {
      type: Object
    },
    //- 当前组件序号
    index: {
      type: Number
    },
    //- draggable 是否可拖拽
    draggable: {
      type: Boolean,
      default: true
    },
    //- resizable 是否可调整大小
    resizable: {
      type: Boolean,
      default: true
    },
    //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
    isFrontEnd: {
      type: Boolean
    },
    //- 是否客户端扩大状态，true是的话明细，汇总显示需要一些细微调整
    drawer: {
      type: Boolean,
      default: false
    },
    // 宽
    width: {
      type: [Number, String],
      default: 0
    },
    // 高
    height: {
      type: [Number, String],
      default: 0
    },
    theme: Object,
    // 是否可复制(容器组件里面的没有)
    copy: {
      type: Boolean,
      default: true
    },
    layoutIndex: Number,
    // btnLimitStatus: {
    //     type: Boolean
    // },
    // 关联清除是否不显示
    isRelevancy: {
      type: Boolean,
      default: false
    },
    layout: {
      type: Array,
      default: () => []
    },
    styleTemp: {
      type: Object
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    customDeskInfo: {
      type: Object,
      default: () => {}
    }
  },
  data: function () {
    return {
      fromdatas: [],
      btnLimitStatus: false,//- 按钮限制点击状态
      iconObj: {
        indicators: 'icon-zhibiaotu',
        bread: 'icon-bingtutubiao',
        proportion: 'icon-mianjitu1',
        columnar: 'icon-zhuzhuangtu1',
        annular: 'icon-huanxingtu1',
        brokenLine: 'icon-zhexiantu1',
        barType: 'icon-tiaoxingtu1'
      },
      bgfillView:false,
      iconUrl: 'https://bigdata.topeti.com/PCRepository/mainPlatform/indicators',
      isTop: false,
      isBottom: false
    }
  },
  inject: ["isSpace"],
  components: {
    IconModule: defineAsyncComponent(() => import('@/components/common/icon/iconModule.vue')),
    multilevelTables: defineAsyncComponent(() => import('../model/multilevelTables.vue')),
    // bgfill:() => import('./bgfill'),//背景填充组件
  },
  mounted () {
  },
  watch: {
    layout: {
      immediate: true,
      deep: true,
      handler () {
        if (!this.isFrontEnd || !this.styleTemp || this.styleTemp && this.styleTemp.absorb && this.styleTemp.absorb !== 'open') return
        this.upJ()
      }
    },
    'styleTemp.absorb': {
      immediate: true,
      deep: true,
      handler (val) {
        console.log('触发调整', val)
        if (this.isFrontEnd && val && val === 'open') this.upJ()
      }
    }
  },
  methods: {
    getTitle () {
      const type = this.data.type
      if (type === 'mutual' || type === 'swiper') return {height:0,padding:0}
      if (type === 'detailed' || type === 'summary') {
        return this.data.nameShow && !this.data.toolbar && (!this.data.titleMom && this.data.titleMom !== '') ? {height:0,padding:0} : ''
      } else if (type === 'indicatorsBread') {
        const s = this.data.nameShow && !this.data.toolbar && (!this.data.titleMom && this.data.titleMom !== '') && !this.data.chartTypeMom
        return s ? {height:0,padding:0} : ''
      } else {
        return this.data.nameShow ? {height:0,padding:0} : ''
      }
    },
    upJ () {
      const obs = this.getTb(this.data)
      this.isTop = obs.isTop
      this.isBottom = obs.isBottom
    },
    getTb (data) {
      const obs = {}
      const x1 = data.x
      const x2 = data.x + data.w
      const y1 = data.y
      const y2 = data.y + data.h
      obs.isTop = this.layout.filter(it => {
        const t1 = it.x
        const t2 = it.x + it.w
        const ty = it.y + it.h
        return it.i !== data.i && ty === y1 && t1 <= x1 && x2 <= t2
      })
      obs.isBottom = this.layout.filter(it => {
        return it.i !== data.i && x1 <= it.x && it.x <= x2 && it.y === y2
      })
      return obs
    },
    setXF (key, val) {
      this.$set(this.data, key, val)
      if (key === 'linkTop' && this.isTop && this.isTop.length > 0) {
        const obs = this.getTb(this.isTop[0])
        let len = 0;
        (obs.isBottom).forEach(it => {
          if (it.i !== this.data.i && it.linkTop) len += 1
        })
        if (len === 0) {
          const ind = this.layout.findIndex(it => it.i === this.isTop[0].i)
          if (ind !== -1) this.$set(this.layout[ind], 'linkBottom', val)
        }
      } else if (key === 'linkBottom' && this.isBottom && this.isBottom.length > 0) {
        const arr = key === 'linkTop' ? this.isTop : this.isBottom
        for (const i of arr) {
          const ind = this.layout.findIndex(it => it.i === i.i)
          if (ind !== -1) this.$set(this.layout[ind], 'linkTop', val)
        }
      }
    },
    upChart (val) {
      console.log('点击upChart', val)
      this.$emit('upchart', val)
    },
    titleBgfillSet (data) {
      const titleBgConfig = data.titleBgConfig
      const transparentBackground = data.transparentBackground
      if (titleBgConfig && !transparentBackground) {
        let fillstyle = {}
        if (titleBgConfig.bgType === 'color') {
          fillstyle.backgroundColor = titleBgConfig.bgColor
        } else if (titleBgConfig.bgType === 'picture') {
          fillstyle.background = `url('${this.$imgurl + titleBgConfig.bgImg}') no-repeat`
          fillstyle.backgroundSize = '100% 100%'
        } else if(titleBgConfig.bgType === 'temp') {
          // 背景填充颜色
          fillstyle.backgroundRepeat = 'no-repeat'
          fillstyle.backgroundSize = '100% 100%'
          if (titleBgConfig.bgTemp === 0 || titleBgConfig.bgTemp === 1) {
            fillstyle.backgroundColor = '#333'
          } 
          if (titleBgConfig.bgTemp === 2) {
            fillstyle.paddingLeft = '26px'
          }
          fillstyle.backgroundImage = `url(https://bigdata.topeti.com/PCRepository/mainPlatform/dashboardTitleBg${titleBgConfig.bgTemp + 1}.png)`
        }
        return fillstyle
      }else{
        return ''
      }
    },
    editDrid () {
      this.$emit('handle', {
        status: 'editDrid',
        index: this.index
      })
    },
    // 同步
    async synchronous (item, index) {
      console.log('同步', item, index)
      const { code } = await refreshapprovalreport({ approvalReportId: item.appId }).catch(err => { console.log(err) })
      if (code === 0) {
        this.$message.success('同步成功！')
        this.update(item, index)
      } else {
        this.$message.error('同步失败！')
      }
    },
    async uploadPDF (item, index) {
      console.log('导出pdf', item, index)
      let mergeRules = [];
      if (item.rules && item.rules != undefined) {
        //- 外置筛选组件的筛选规则
        mergeRules = mergeRules.concat(item.rules);
      }
      if (item.relevanceRules && item.relevanceRules != undefined) {
        //- 表单关联表单的筛选规则
        mergeRules = mergeRules.concat(item.relevanceRules);
      }
      let contrastVal = []
      let isBasis = false
      if (item.toolbarConfig && item.toolbarConfig.length > 0) {
        const ss = toolbarSearch(item.toolbarConfig, mergeRules)
        mergeRules = ss.list
        contrastVal = ss.contrast
        isBasis = ss.isBasis
      }
      const submitDatas = {
        approvalDashboardId: this.$route.query.dataReportId || this.customDeskInfo.dataReportId,//- 仪表盘id
        index: this.layoutIndex,//- 仪表盘索引
        value: JSON.stringify(mergeRules),//- 筛选组件提交的筛选值
        curpage: 1,//- 当前页 (如果是汇总，该值传0)
        pagesize: 999999,//- 每页条数 (如果是汇总，该值传0)
        export: '',//- 是否导出数据,1为导出，其它不导出
        ref: 0,
        querys: item.querys ? item.querys : '',//- 仪表盘验证过滤数据
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
        let spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
        submitDatas.spaceid = spaceId;
      }
      else if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        submitDatas.upaceid = upaceId
      }
      const customDataList = this.$store.state.dashboardCustomData
      if (customDataList) {
        // 存在$就是自定义的变量
        submitDatas.customData = setCustomData(customDataList)
      }
      const res = await apiUpateview(submitDatas).catch(err => { console.log(err) })
      
      console.log('汇总查询结果', res)
        if (res.code === 0) {
          let add_table = this.changeSummary(JSON.parse(JSON.stringify(res.data.list)), JSON.parse(JSON.stringify(item.column)));

          let date = this.mergeFun(res.data.list);
          // 特殊加料
          let row = item.row;
          let column = item.column;
          if (row && row.length > 0 && date && date.length > 0) {
            for (let i = 0; i < row.length; i++) {
              const rowItem = row[i]
              if ((row[i].type === 'date' || row[i].type === 'number') && row[i].format) {
                const rowName = (rowItem.revisabilityName || rowItem.name)
                for (let a = 0; a < date.length; a++) {
                  date[a][rowItem.revisabilityName || rowItem.name] = date[a][rowName] || date[a][rowName] === 0 ? date[a][rowName] : date[a][rowName + '显示格式']
                }
              }
            }
          }
          if (column && column.length > 0 && date && date.length > 0) {
            for (let i = 0; i < column.length; i++) {
              const columnItem = column[i]
              const columnName = (columnItem.revisabilityName || columnItem.name)
              for (let a = 0; a < date.length; a++) {
                date[a][columnItem.revisabilityName || columnItem.name] = date[a][columnName] || date[a][columnName] === 0 ? date[a][columnName] : date[a][columnName + '显示格式']
              }
            }
          }

          // let table = serverPageSummary({...res.data, list: date}, item.column, item.row, item.summary, item.isSummary, { curpage: res.curpage, pages: res.pages });
          let table = serverPageSummary({...res.data, list: date}, item.column, item.row, item.summary, item.isSummary, { curpage: res.curpage, pages: res.pages }, { contrastVal: contrastVal, pool: item.poolConfig, isPool: item.contrast, isBasis: isBasis });


          console.log('查看汇总结果', table, res.data)
          let tableList = JSON.parse(JSON.stringify(table.list));
          let beifengArr = tableList[tableList.length - 1];//- 汇总字段单独保存


          let concatObject = add_table.map((item, index) => {
            // 删掉有 特殊字符的
            for (const i in item) {
              if (i.includes('\u0001')) delete item[i]
            }
            return { ...item, ...tableList[index] };
          })

          // item.topCount = table.topCount;//- 记录除汇总列以外的列数，为点击汇总表格点击事件做准备
          // item.merge = table.top;
          // item.pageTotal = res.total;
          // item.pages = res.pages;
          if (item.isSummary == 1) {
            //- 是自动汇总
            concatObject = concatObject.concat(beifengArr);  // 结果集
          }

          this.$set(this, 'fromdatas', concatObject)

        } else {

          this.$message({
            showClose: true,
            type: 'info',
            message: item.reName + ',表格数据获取失败'
          });
        }
      this.$refs.multilevelTable.printFun()
    },
    tableMerge (listTable, datas) {
      let ars = [];
      let tableData = listTable;
      let retName = '';
      for (let a = 0; a < (datas.row || []).length; a++) {
        let arsArr = [];
        let post = 0;
        let rowNames = filterStr(datas.row[a].name);
        // let rowNames = filterSymbol(datas.row[a].name);
        if (a > 0) retName = filterStr(datas.row[a - 1].name);
        // if (a > 0) retName = filterSymbol(datas.row[a - 1].name);
        // console.log('计算合并', tableData, datas.row[a], rowNames)
        for (let i = 0; i < tableData.length; i++) {
          if (i === 0) {
            arsArr.push(1);
            post = 0;
          } else {
            // 这里需要区分 row 是不是第一个
            if (a === 0) {
              if (JSON.stringify(tableData[i][rowNames]) === JSON.stringify(tableData[i - 1][rowNames])) {
                arsArr[post] += 1;
                arsArr.push(0);
              } else {
                arsArr.push(1);
                post = i;
              }
            } else {
              let one = tableData[i][retName] + tableData[i][rowNames];
              let two = tableData[i - 1][retName] + tableData[i - 1][rowNames];
              if (one === two) {
                arsArr[post] += 1;
                arsArr.push(0);
              } else {
                arsArr.push(1);
                post = i;
              }
            }
          }
        }
        ars.push(arsArr);
      }
      return ars;
    },
    changeSummary (data, column) {
      let columnLength = column.length;
      if (data && data.length > 0) {
        data.forEach(item => {
          for (var j in item) {

            let keyName = j.split(/\1{1}/g);
            if ((keyName.length - 1) == columnLength) {
              column.forEach((item2, i2) => {
                // item[item2.name] = keyName[i2];
                if (!item[item2.name]) {
                  let newArray = [];
                  newArray.push(keyName[i2]);
                  item[item2.name] = newArray;
                } else {
                  let array = item[item2.name];
                  if (keyName[i2] != '' && array.indexOf(keyName[i2]) == -1) {
                    array = array.push(keyName[i2]);
                  }

                }

              })

            }
          }
        })
      }
      return data;
    },
    //- 指标图/饼图客户端数据格式改造(2)
    mergeFun (date) {
      let arr = [];
      if (date && date.length > 0) {
        for (let i = 0; i < date.length; i++) {
          let str = {};
          for (let e in date[i]) {
            if (typeof date[i][e] === 'object') {
              let retStr = this.retsule(date[i][e], e);
              str = Object.assign(str, retStr);
            } else {
              str[e] = date[i][e];
            }
          }
          arr.push(str);
        }

      }

      return arr;
    },
    //- 指标图/饼图/汇总/明细客户端数据格式改造
    retsule (data, name) {
      let strObj = {};
      // 区分 [] 和 {}
      if (Array.isArray(data)) {
        if (data[0] && data[0].realname) {
          let ars = data.map(val => { return val.realname });
          strObj[name] = ars.join(',');
        } else if (data[0] && data[0].response) {
          strObj[name] = data;
        } else if (data[0] && data[0].date && data[0].time) {
          // 他是属于预约时间段的，不做任何转化
          strObj[name] = data
        } else {
          strObj[name] = data.join(',');
        }
      } else {
        if (data.realname) {
          strObj[name] = data.realname;
        } else {
          for (let i in data) {
            if (typeof data[i] === 'object') {
              let retStrs = this.retsule(data[i], (name + '.' + i));
              strObj = Object.assign(strObj, retStrs);
            } else {
              strObj[name + '.' + i] = data[i];
            }
          }
        }
      }
      return strObj;
    },

    viewFun () {
      this.$emit('handle', {
        status: 'show',
        item: this.data,
        index: this.index
      })
    },
    //- 判断是否可以
    panduanCanUpload () {
      let whether = true;
      if (this.data.type == "indicatorsBread" && this.data.chartType == "indicators" && this.data.isRowVirtual == true) {
        whether = false;
      } else if (!this.data.isCav || this.data.isCav == 2) {
        whether = false;
      }
      return whether
    },
    //- 名称显示判断
    classNameShow () {
      if (this.data.type === 'detailed' && this.drawer == true || this.data.type === 'summary' && this.drawer == true || this.data.type === 'indicatorsBread' && this.drawer == true) {
        return 'selectBoxArea Boxright'
      } else if (this.data.type === 'text' && this.isFrontEnd === false) {
        return 'selectBoxArea textStyle'
      } else {
        return 'selectBoxArea'
      }

    },
    //- 明细表，汇总表，筛选组件功能区-删除
    delDrid (index) {
      this.$emit("handle", {
        status: 'delete',
        index: index
      });
      // this.$parent.delDrid(index);
    },
    //- 明细表，汇总表功能区-复制
    cropGrid (item) {
      // this.$parent.cropGrid(item);
      this.$emit("handle", {
        status: 'copy',
        item: item
      });
    },
    //- 明细表，汇总表，筛选组件功能区-修改
    goUp (item) {
      // this.$parent.goUp(item);
      if (this.width) item.width = this.width
      if (this.height) item.height = this.height
      this.$emit("handle", {
        status: 'amend',
        item: item
      });

    },
    //- 明细表，汇总表组件功能-扩大显示
    enlarge (item, index) {
      this.$emit("handle", {
        status: 'enlarge',
        item: item,
        index: index
      });
    },
    //- 明细表，汇总表组件功能-更新数据
    update (item, index) {
      if (this.btnLimitStatus == true) {
        return;
      } else {
        this.btnLimitStatus = true;
        var timeLimit = setTimeout(() => {
          this.btnLimitStatus = false;
          clearTimeout(timeLimit);
        }, 30000)

      }
      this.$emit("handle", {
        status: 'update',
        item: item,
        index: index,
      });
    },
    //- 明细表，汇总表组件功能-下载数据
    upload (item, index) {
      this.$emit("handle", {
        status: 'upload',
        item: item,
        index: index
      });
    },
    //- 新增功能：清除关联表单数据
    empty (index) {
      this.$emit("handle", {
        status: 'empty',
        index: index
      });

    },
    // 关闭背景填充设置
    closeFill(type){
      this.bgfillView = type
    },
  }
}
</script>
<style lang="scss" scoped>
.xf-top {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}
.xf-bottom {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}
.chartList {
  display: flex;
  align-items: center;
  .chart-l {
    width: 24px;
    height: 24px;
    border-radius: 2px;
    background-color: #FFFFFF;
    border: 1px solid #D8D9D7;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-left: 4px;
    i {
      font-size: 10px;
      margin-right: 0;
    }
    img {
      width: 16px;
      height: 15px;
      margin-right: 0 !important;
    }
  }
  .chart-active {
    border-color: #037EFF;
  }
}
.down-b {
  cursor: pointer;
  line-height: 24px;
  padding: 0 12px;
  border-radius: 6px;
  &:hover {
    background-color: #4e86ff;
    color: #ffffff;
  }
}
.selectBoxArea {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 11px;
  height: 40px;
  margin-left: -11px;
  margin-right: -11px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  &.textStyle {
    height: 2px;
  }
  .title {
    width: 100%;
    // overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #000000;
    font-size: 20px;
    //color: #082943;
    font-weight: bold;
    // display: inline-block;
    display: flex;
    align-items: center;
    // align-items: initial;
    i {
      font-weight: normal;
      margin-right: 5px;
    }
    img {
      margin-right: 4px;
    }
    .icon-module {
      margin-right: 6px;
    }
  }
  .title-cc {
    :deep(.select-box-toolbar), :deep(.content-toolbar) {
      padding-left: 8px;
    }
  }

  .coverIsShow {
    width: 100%;
    height: 39px;
    background: rgba(0, 0, 0, 0);
    position: absolute;
    left: 0;
    top: 46px;
    z-index: 99;
  }
  &.Boxright {
    position: absolute;
    display: inline-block;
    top: 14px;
    right: 44px;
    /*width: 164px;*/
  }
  .selectBox:hover .select-box-right {
    transform: translate(-18px, -50%);
    // width: 200px;
    width: auto;
    display: flex;
    align-items: left;
    overflow: auto;
    padding-left: 10px;
  }
  .selectBox {
    // display: none;
    align-items: center;
    // overflow: hidden;
    position: relative;
    z-index: 1;
    .select-box-right {
      width: 0;
      overflow: hidden;
      // width: 200px;
      transition: 0.3s;
      transform: translate(0, -50%);
      background-color: #ffffff8a;
      line-height: 37px;
      position: absolute;
      right: 0;
      z-index: 9999;
      border-radius: 4px;
      top: 50%;
    }
    .icon-unfold {
      cursor: pointer;
      margin-left: 10px;
      float: right;
    }

    .icon-click-style {
      text-align: center;
      border-radius: 2px;
      display: inline-block;
      cursor: pointer;
      float: right;
      margin-right: 11px;
      /*&:first-child {*/
      /*  margin-right: 0;*/
      /*}*/
      &.disabled {
        background: rgba(212, 203, 203, 0.5);
        color: white;
        cursor: not-allowed;
      }
    }
    .iconstyle {
      line-height: 39px;
      text-align: center;
      float: right;
      background: rgba(255, 255, 255, 1);
      -webkit-box-shadow: 0px 2px 4px 0px rgba(186, 186, 186, 0.5);
      box-shadow: 0px 2px 4px 0px rgba(186, 186, 186, 0.5);
      border-radius: 2px;
      display: inline-block;
      cursor: pointer;
      // margin: 5px 5px;
      margin-right: 5px;
      padding: 0px 10px;
      &:i {
        display: inline-block;
        font-size: 14px;
      }
    }
  }
  .admin-selectBox {
    display: none;
  }
/*
  .admin-selectBox {
    &:hover {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: #dcdcdc;
      z-index: 2;
      top: 0;
      left: 0;
      justify-content: center;
      color: #ffffff;
      border-radius: 4px;
    }
  }
*/
  // &:hover .selectBox {
  //     display: block !important;
  // }
}
.bgfill{
  float: right;
  padding: 0 10px;
  cursor: pointer;
  .icon-shezhi21{
    font-size: 12px;
  }
}
</style>
